import reactDOM from 'react-dom';

import { Icon } from '../Icon/Icon';
import './Toast.css';

interface Props {
  message: string;
  type: 'success' | 'error';
  id: string;
  removeToast(id: string): void;
}

function Toast({ message, type, id, removeToast }: Props) {
  const modalContainer: HTMLElement | null = document.getElementById('modal');

  if (!modalContainer) return null;

  return reactDOM.createPortal(
    <button className={`toast ${type}`} type="button" onClick={() => removeToast(id)}>
      {type === 'success' ? (
        <Icon.Check className="icon-small" />
      ) : type === 'error' ? (
        <Icon.Alert className="icon-small" />
      ) : null}
      {message}
    </button>,
    modalContainer,
  );
}

export default Toast;
